import gql from 'graphql-tag';
import { PageInfoFragment } from './messages.fragments';

export const messagesQuery = gql`
	query TenantMassMessages(
		$after: String
		$first: Int
		$last: Int
		$before: String
		$offset: Int
		$locations: [UUID]
	) {
		tenantMassMessages(
			after: $after
			first: $first
			last: $last
			before: $before
			offset: $offset
			locations: $locations
		) {
			edges {
				node {
					pk
					created
					subject
					text
					state
					recipients
					createdBy {
						contentType
						firstName
						lastName
						name
						psId
						smallAvatarUrl
						smallLogoUrl
					}
					locations {
						name
						locationId
						id
						locationType
					}
					organizationPsId
					attachments {
						pk
						name
						type
						importId
						importConfirmed
						file {
							url
							name
							contentType
						}
						createdBy {
							contentType
							firstName
							lastName
							name
							psId
							smallAvatarUrl
							smallLogoUrl
						}
						created
						classificationsV2 {
							name
							type
							pk
						}
					}
				}
			}
			pageInfo {
				...PageInfoFragment
			}
			totalCount
		}
	}
	${PageInfoFragment}
`;
